module.exports = __webpack_public_path__ + "img/4.56eca45c.jpg";